var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0882 2.5H12.0294C9.50205 2.5 7.07821 3.50399 5.2911 5.2911C3.50399 7.07821 2.5 9.50205 2.5 12.0294C3.62947 30.6153 11.522 48.1452 24.6884 61.3116C37.8549 74.478 55.3847 82.3705 73.9706 83.5C76.4979 83.5 78.9218 82.496 80.7089 80.7089C82.496 78.9218 83.5 76.4979 83.5 73.9706V54.9118L59.6765 45.3824L52.5294 57.2941C42.1827 52.1913 33.8087 43.8173 28.7059 33.4706L40.6176 26.3235L31.0882 2.5Z",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector13);
export default __webpack_public_path__ + "static/media/Vector (13).d7668959193692f8dad17e4f4c91044b.svg";
export { ForwardRef as ReactComponent };